import { For } from 'solid-js'

function hashSeed(input: string): number {
	let h = 0
	for (let i = 0; i < input.length; i++) {
		h = (Math.imul(31, h) + input.charCodeAt(i)) | 0
	}
	return h >>> 0
}

function mulberry32(a: number) {
	return () => {
		a |= 0
		a = (a + 0x6d2b79f5) | 0
		let t = Math.imul(a ^ (a >>> 15), 1 | a)
		t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
		return ((t ^ (t >>> 14)) >>> 0) / 4294967296
	}
}

const W = 320
const H = 180

function CandleMotif(props: { rand: () => number }) {
	let base = H * 0.55
	let cx = 18
	const candles = Array.from({ length: 24 }, () => {
		const o = base
		const dir = props.rand() > 0.48 ? -1 : 1
		const body = 6 + props.rand() * 26
		const nc = o + dir * body
		const wick = 8 + props.rand() * 14
		const up = dir < 0
		const color = up ? '#26c281' : '#e5483d'
		const result = { x: cx, top: Math.min(o, nc), bottom: Math.max(o, nc), wick, color }
		base = nc + (props.rand() - 0.5) * 10
		base = Math.max(30, Math.min(H - 24, base))
		cx += 12.4
		return result
	})

	return (
		<For each={candles}>
			{(c) => (
				<>
					<line x1={c.x} y1={c.top - c.wick} x2={c.x} y2={c.bottom + c.wick} stroke={c.color} stroke-width="1.3" stroke-opacity="0.85" />
					<rect x={c.x - 4} y={c.top} width="8" height={Math.max(3, c.bottom - c.top)} fill={c.color} opacity="0.9" />
				</>
			)}
		</For>
	)
}

function LineMotif(props: { rand: () => number; color: string }) {
	let y = H * 0.6
	const points: string[] = []
	for (let i = 0; i <= 16; i++) {
		y += (props.rand() - 0.52) * 22
		y = Math.max(24, Math.min(H - 20, y))
		points.push(`${i * 20},${y.toFixed(1)}`)
	}
	const line = points.join(' ')
	return (
		<>
			<polyline points={line} fill="none" stroke={props.color} stroke-width="2.2" stroke-opacity="0.95" />
			<polyline points={`0,${H} ${line} ${W},${H}`} fill={props.color} opacity="0.1" stroke="none" />
		</>
	)
}

function SlideMotif(props: { rand: () => number; color: string }) {
	return (
		<>
			<rect x="26" y="26" width={W - 52} height={H - 64} rx="6" fill="#ffffff" fill-opacity="0.06" stroke="#ffffff" stroke-opacity="0.10" />
			<rect x="42" y="44" width={W * 0.42} height="10" rx="3" fill={props.color} opacity="0.85" />
			<For each={[0, 1, 2, 3]}>
				{(i) => (
					<rect x="42" y={68 + i * 16} width={W * (0.55 - i * 0.08)} height="6" rx="3" fill="#ffffff" fill-opacity={0.22 - i * 0.03} />
				)}
			</For>
			<circle cx={W - 70} cy={H * 0.5} r="26" fill="none" stroke={props.color} stroke-width="6" stroke-opacity="0.5" stroke-dasharray={`${90 + props.rand() * 70} 400`} />
		</>
	)
}

export default function Motif(props: { seed: string; color: string }) {
	const seedNum = hashSeed(props.seed)
	const rand = mulberry32(seedNum)
	const bg = rand() > 0.5 ? '#0d1420' : '#0f1117'
	const kind = Math.floor(rand() * 3)

	return (
		<svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="xMidYMid slice" width="100%" height="100%" style={{ display: 'block' }} aria-hidden="true">
			<rect width={W} height={H} fill={bg} />
			<For each={Array.from({ length: 7 }, (_, i) => (i + 1) * 40)}>
				{(x) => <line x1={x} y1="0" x2={x} y2={H} stroke="#ffffff" stroke-opacity="0.04" />}
			</For>
			<For each={Array.from({ length: 4 }, (_, i) => (i + 1) * 36)}>
				{(y) => <line x1="0" y1={y} x2={W} y2={y} stroke="#ffffff" stroke-opacity="0.04" />}
			</For>
			{kind === 0 && <CandleMotif rand={rand} />}
			{kind === 1 && <LineMotif rand={rand} color={props.color} />}
			{kind === 2 && <SlideMotif rand={rand} color={props.color} />}
		</svg>
	)
}
